import { useState } from 'react';
import { faqData } from '@/mocks/about';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section id="faq" className="px-4 md:px-6 py-10 md:py-14">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-800">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">关于奇优影院的常见疑问解答</p>
        </div>
        <div className="space-y-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="rounded-lg bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-200/50 transition-colors cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-800 pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-600 transition-transform duration-200 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}